<ng-template #modalDeleteSubscription let-c="close" let-d="dismiss">
  <wsb-modal
    (primary)="modalSubscriptionDeleteForm()"
    (dismiss)="d()"
    cancelButtonEnable="true"
    title="{{ 'common_attention' | translate }}"
    text="{{ 'subscription_delete_confirm' | translate }}"
  ></wsb-modal>
</ng-template>
<ng-template #modalUpgradeSubscription let-c="close" let-d="dismiss">
  <wsb-modal
    cancelButtonEnable="true"
    cancelButtonText="common_close"
    [primaryButtonEnable]="false"
    (dismiss)="d()"
    title="{{ 'shop_upgrade_sub' | translate }}"
  >
    <div body>
      <ng-container *ngFor="let item of itemUpgrades; let i = index">
        <wsb-atlas-grid
          *ngIf="item.shop.showTable"
          class="atlas-grid-simplest"
          [loading]="!item.shop"
          [columnDefs]="item.shop.columns"
          [rowData]="item.shop.data"
          [options]="item.shop.options"
          [components]="item.shop.components"
        ></wsb-atlas-grid>
      </ng-container>
    </div>
  </wsb-modal>
</ng-template>

<h3 class="my-5" translate>billing_tab_subscription</h3>
<div class="my-5">
  <wsb-atlas-grid
    #gridSubscriptions
    class="atlas-grid-simplest"
    class="mt-2"
    *ngIf="tableSubscriptionsGridOptions"
    [loading]="tableSubscriptionsLoading"
    [@gridIsLoaded]="gridAnimationState"
    [columnDefs]="tableSubscriptionsColumnDefs"
    [options]="tableSubscriptionsGridOptions"
    [components]="components"
  ></wsb-atlas-grid>
</div>
